import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "slash-forward-20", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "currentColor", d: "M8.929 15.372a1 1 0 0 1-1.857-.743l4-10a1 1 0 0 1 1.857.743l-4 10z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
